export const MUT_GET_SUBS = 'MUT_GET_SUBS';
export const MUT_SET_SUBS = 'MUT_SET_SUBS';
export const MUT_ERR_SUBS = 'MUT_ERR_SUBS';
